module.exports = __webpack_public_path__ + "img/gall-1.37a2db9e.jpg";